import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box } from "@mui/material";
import { Gray600 } from "../../../styles/color";

const MeetingRoomInfoMessage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        fontSize: "0.8125rem",
        color: Gray600,
        gap: 0.5,
        px: 1,
        py: 1,
      }}
    >
      <Box display="flex" alignItems="center" fontWeight={600} mb={0.5}>
        <InfoOutlinedIcon sx={{ fontSize: "1rem", mr: 0.5, mt: "3px" }} />
        예약 전 안내사항
      </Box>
      <Box>
        · 예약하기를 누른 뒤 회의실을 변경할 경우, 참조를 지우고 회의실을 변경해
        주세요.
      </Box>
      <Box>
        · 개인 일정 목록을 사용하는 경우, 기본 일정을 선택하여 예약해 주세요.
      </Box>
      <Box>
        · 예약이 완료되기까지 시간이 소요될 수 있습니다. 1~2분 후 새로고침하여
        확인해주세요.
      </Box>
    </Box>
  );
};
export default MeetingRoomInfoMessage;
